import Vue from 'vue'
import Vuex from 'vuex'
import util from './utils/util'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    Token: util.getUserToken(),
    activityDetail: {},
    couponDetail: {}
  },
  mutations: {
    setToken (state, token) {
      state.Token = token
      util.setUserToken(token)
    },
    setActivityDetail (state, detail) {
      state.activityDetail = detail
    },
    setCouponDetail (state, detail) {
      state.couponDetail = detail
    }
  },
  actions: {
  }
})
export default store
